import { graphql } from 'gatsby';
import { getKey, isValidArray, getLink } from '../../../helpers';

/**
 * Step widget definition
 * @param {Object} props of the widget
 * @param {string} locale of the strings
 * @returns {Object} widget definition
 */
export const step = function (props, locale) {
  const items = getKey(props, 'featureitems');

  return {
    widgetType: 'step',
    key: getKey(props, 'key'),
    isPurple: getKey(props, 'isPurple'),
    items: isValidArray(items) && items.map(item => ({
      key: getKey(item, 'id'),
      title: getKey(item, `title_${locale}`),
      description: getKey(item, `description_${locale}`),
      callToAction: getKey(item, `callToAction_${locale}`),
      icon: getKey(item, 'icon.image.url'),
      link: getLink(getKey(item, 'link'), locale),
    }))
  };
}


/**
 * Step widget definition
 * @param {Object} props of the widget
 * @param {string} locale of the strings
 * @returns {Object} widget definition
 */
export default function stepProvider(props, locale) {
  const key = getKey(props, 'key');

  return {
    locale,
    stepId: key
  };
}

/**
 * GraphQL query
 */
export const query = graphql`
  fragment Steps on StrapiWidgetrels {
    step {
      key: id
      items: featureitems {
        id
        title_en
        title_es
        description_en
        description_es
        callToAction_en
        callToAction_es
        icon {
          image {
            publicURL
          }
        }
        link
      }
      isPurple
      widgetPosition
    }
  }
`;
